import { create } from "zustand";

interface PostDataState {
  postDataMap: Record<string, { id: number; slug: string }>
  setPostData: (slug: string, id: number) => void
  getPostId: (slug: string) => number | undefined
}

export const usePostIdStore = create<PostDataState>((set, get) => ({
  postDataMap: {},
  setPostData: (slug: string, id: number) =>
    set((state: PostDataState) => ({
      postDataMap: {
        ...state.postDataMap,
        [slug]: { id, slug },
      },
    })),
  getPostId: (slug: string): number | undefined => {
    const state = get()
    return state.postDataMap[slug]?.id
  },
}))

